export default {
      id: "color_locker_wgs-usage",
      viewBox: "0 0 20 29",
      url: __webpack_public_path__ + "sprite.svg#color_locker_wgs",
      toString: function () {
        return this.url;
      }
    }